import React, { Component } from "react";

class Retry extends Component {
    render() {
        return (
            <div className="overLay">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10 col-xl-8">
                            <div className="card mt-7">
                                <div className="card-body text-center">
                                    <div className="row justify-content-center">
                                        <div className="col-12 col-md-10 col-xl-9">
                                            <h2 className="text-muted large-font mb-4">
                                                <b>Unfortunately, you did not pass for the following reason:</b>
                                            </h2>
                                            {this.props.questions != null ?
											<div className="qsnlistWrapper">
                                                <ul className="qsnlist">
                                                    {this.props.questions && this.props.questions.map( (e, k) => <li key={e.id} className="text-muted">{k+1}. INCORRECT: {e.question}</li>)}
                                                </ul>
                                            </div>
                                            : null}
                                            <p className="text-muted mt-4">
                                                Sorry! Your score was not high
                                                enough to pass the proficiency
                                                test. <span className="highlight">You have one attempt
                                                remaining.</span> Click the “Start Quiz
                                                Again” button below to attempt
                                                the quiz one more time. If you
                                                do not pass a second time, you
                                                will still be able to complete
                                                your registration but your
                                                account may not be approved.
                                            </p>
                                            <p className="text-muted mt-3">
                                                <strong>IMPORTANT NOTE</strong>{" "}
                                                : Please do not switch tabs or
                                                open a new window when taking
                                                the test. This will result in
                                                your test being marked as
                                                invalid.
                                            </p>
                                            <button
                                                onClick={this.props.retry}
                                                className="btn btn-primary mt-4"
                                            >
                                                Start Quiz Again
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default Retry;



// WEBPACK FOOTER //
// ./src/components/writer/quiz/Retry.js